import { Component, inject, OnInit } from '@angular/core';
import { TopProductsListConfigService } from '../../services/top-products-list-config/top-products-list-config.service';

@Component({
    selector: 'lib-top-sold-articles',
    templateUrl: './top-sold-articles.component.html',
    styleUrls: ['./top-sold-articles.component.css'],
    standalone: false
})
export class TopSoldArticlesComponent implements OnInit {
  public topProductListConfig = inject(TopProductsListConfigService);

  ngOnInit(): void {}

  setDateRange(change: { from?: string; to?: string }): void {
    this.topProductListConfig.dateRange.next({ ...this.topProductListConfig.dateRange.value, ...change });
  }
}
